export const riskConstants = {
    NONE: { risk: 'NONE', text: 'Nema', color: '#878a99' },
    LOW: { risk: 'LOW', text: 'Niski', color: '#0ab39c' },
    MEDIUM: { risk: 'MEDIUM', text: 'Srednji', color: '#f7b84b' },
    HIGH: { risk: 'HIGH', text: 'Visoki', color: '#e82c2c' },
    DEFAULT: { risk: '', text: '', color: '' },
}
